// IMPORT ICONS
import adhd from '../../assets/track_icons/ADHD.png';
import community_nursing from '../../assets/track_icons/community_nursing.png';
import emergency_trauma_nursing from '../../assets/track_icons/emergency&trauma_nursing.png';
import geriatric_nursing from '../../assets/track_icons/geriatric_nursing.png';
import neonatal_nursing from '../../assets/track_icons/neonatal_nursing.png';
import oncology_cancer_care from '../../assets/track_icons/oncology&Cancer_care.png';
import pediatric_nursing from '../../assets/track_icons/pediatric_nursing.png';
import autism from '../../assets/track_icons/Autism.png';
import critical_care_nursing from '../../assets/track_icons/critical_care_nursing.png';
import epidemiology from '../../assets/track_icons/Epidemiology.png';
import infection_control_prevention from '../../assets/track_icons/infection_control_prevention.png';
import neurodiversity from '../../assets/track_icons/Neurodiversity.png';
import pain_management from '../../assets/track_icons/pain_management.png';
import radiology_nursing from '../../assets/track_icons/Radiology_nursing.png';
import chronic_disease_management from '../../assets/track_icons/chronic_disease_management.png';
import dentistry from '../../assets/track_icons/Dentistry.png';
import genetic_disorder from '../../assets/track_icons/genetic_disorder.png';
import mental_health_nursing from '../../assets/track_icons/mental_health_nursing.png';
import neurological_nursing from '../../assets/track_icons/neurological_nursing.png';
// import palliative_care from '../../assets/track_icons/Palliative Care.png';
import reproductive_health from '../../assets/track_icons/reproductive_health.png';

// EXPORT TRACKS
export const tracks = [
  { name: "ADHD", icon: adhd },
  { name: "Community Nursing", icon: community_nursing },
  { name: "Emergency & Trauma Nursing", icon: emergency_trauma_nursing },
  { name: "Geriatric Nursing", icon: geriatric_nursing },
  { name: "Neonatal Nursing", icon: neonatal_nursing },
  { name: "Oncology & Cancer Care", icon: oncology_cancer_care },
  { name: "Pediatric Nursing", icon: pediatric_nursing },
  { name: "Autism", icon: autism },
  { name: "Critical Care Nursing", icon: critical_care_nursing },
  { name: "Epidemiology", icon: epidemiology },
  { name: "Infection Control & Prevention", icon: infection_control_prevention },
  { name: "Neurodiversity", icon: neurodiversity },
  { name: "Pain Management", icon: pain_management },
  { name: "Radiology Nursing", icon: radiology_nursing },
  { name: "Chronic Disease Management", icon: chronic_disease_management },
  { name: "Dentistry", icon: dentistry },
  { name: "Genetic Disorders", icon: genetic_disorder },
  { name: "Mental Health Nursing", icon: mental_health_nursing },
  { name: "Neurological Nursing", icon: neurological_nursing },
  // { name: "Palliative Care", icon: palliative_care },
  { name: "Reproductive Health", icon: reproductive_health }
];